// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Services
import Agreement from 'services/data/agreement';

// Actions
import * as actions from './store/actions';

// Components
import { Page, PageHeader, PageContent, Tabs, Tab } from 'components/page';
import SVG from 'components/widgets/icons/svg';

// Component
class ViewAgreement extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    currentUser: PropTypes.object,
    agreement: PropTypes.object,
    children: PropTypes.node,
    fetching: PropTypes.bool
  };

  static defaultProps = {
    agreement: {}
  };

  constructor(props) {
    super(props);

    this.load = this.load.bind(this);
  }

  componentDidMount() {
    this.load(this.props.id, true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) this.load(nextProps.id, true);
  }

  load(id, fetching = false) {
    if (fetching) actions.set({ fetching: true });
    const load = ['company', 'rates', 'signedAgreements', 'billings'];

    Agreement.findOne(id || this.props.id, { load })
      .then(agreement => {
        actions.set({ fetching: false, agreement });
      });
  }

  render() {
    const { agreement, fetching, children } = this.props;
    const clonedChildren = React.cloneElement(children, {
      load: this.load
    });

    if (!agreement || _.isEmpty(agreement)) return null;

    return (
      <Page className="agreement-page">
        <PageHeader title={agreement.title}>
          <Tabs className="actions-tabs">
            <Tab to={`/admin/agreements/${agreement.id}/summary`}>
              <SVG src="svg/agreement.svg" className="agreement" />
              <span>Summary</span>
            </Tab>
            <Tab to={`/admin/agreements/${agreement.id}/billings`}>
              <SVG src="svg/billing.svg" className="billing" />
              <span>Billings</span>
            </Tab>
          </Tabs>
        </PageHeader>
        <PageContent fetching={fetching} className="agreement bg-medium-blue-grey">
          {clonedChildren}
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state, ownProps) => ({
  fetching: state.agreements.fetching,
  agreement: state.agreements.agreement,
  id: ownProps.routeParams.agreementId,
  currentUser: state.auth.currentUser
}))(ViewAgreement);
